import { useEffect } from 'react'

import { useUnrepliedCommentsCount } from './useUnrepliedCommentsCount'

/**
 * Sync unreplied comment count via custom event for external apps
 */
export const useSyncUnrepliedCommentsCount = (): void => {
  const { totalCount, loading, error } = useUnrepliedCommentsCount()

  useEffect(() => {
    const { eventKeys } = window.appshell || {}

    if (!eventKeys?.UNREPLIED_COMMENTS_COUNT_EVENT_KEY) return

    window.dispatchEvent(
      new CustomEvent(eventKeys.UNREPLIED_COMMENTS_COUNT_EVENT_KEY, {
        detail: {
          count: totalCount,
          loading,
          error,
        },
      }),
    )
  }, [totalCount, loading, error])
}
